import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { pickFunction } from 'Helpers/Affordances';
import LogsContainer from './LogsContainer';
import { LogsProvider } from './LogsContainer/LogsContext';

const LogsPicker = ({ resource }) => {
  return pickFunction(resource, {
    [fr.relationships.logs.name]: () => {
      return (
        <LogsProvider tabResource={resource}>
          <LogsContainer />
        </LogsProvider>
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};


LogsPicker.defaultProps = {};

LogsPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default LogsPicker;
